import { useState } from 'react';
import { Form, Input, Button, Space } from 'antd';
import { calculateBirthTime, earthBranches, getElement, heavenStems } from '../../utils';
import { getColor } from '../../components/FourPillars';

export const Fantui = () => {
  const [birthTimes, setBirthTimes] = useState<Array<{ solar: string, lunar: string }>>([]);
  const [form] = Form.useForm();

  const onFinish = (values: { year: string; month: string; day: string; hour: string }) => {
    const { year, month, day, hour } = values;
    const calculatedTimes = calculateBirthTime(year, month, day, hour);
    setBirthTimes(calculatedTimes);
  };

  const handleStemBranchClick = (value: string) => {
    const fields = ['year', 'month', 'day', 'hour'];
    for (const field of fields) {
      const currentValue = form.getFieldValue(field) || '';
      if (currentValue.length < 2) {
        form.setFieldsValue({ [field]: currentValue + value });
        break;
      }
    }
  };

  const renderStemBranchButtons = () => (
    <>
      <div style={{ marginBottom: '10px' }}>
        <Space wrap>
          {heavenStems.map(stem => (
            <Button key={stem} style={{
              color: getColor(getElement(stem)), fontSize: '20px',
              fontWeight: 600
            }} onClick={() => handleStemBranchClick(stem)}>{stem}</Button>
          ))}
        </Space>
      </div>
      <div style={{ marginBottom: '10px' }}>
        <Space wrap>
          {earthBranches.map(branch => (
            <Button key={branch} style={{
              color: getColor(getElement(branch)), fontSize: '20px',
              fontWeight: 600
            }} onClick={() => handleStemBranchClick(branch)}>{branch}</Button>
          ))}
        </Space>
      </div>
    </>
  );

  return (
    <div>
      {renderStemBranchButtons()}
      <Form form={form} onFinish={onFinish}>
        <Form.Item name="year" label="年柱">
          <Input />
        </Form.Item>
        <Form.Item name="month" label="月柱">
          <Input />
        </Form.Item>
        <Form.Item name="day" label="日柱">
          <Input />
        </Form.Item>
        <Form.Item name="hour" label="时柱">
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            计算
          </Button>
        </Form.Item>
      </Form>
      {birthTimes.length > 0 && (
        <div>
          <h3>推算的出生时间:</h3>
          {birthTimes.map((time, index) => (
            <div key={index}>
              <p>公历: {time.solar}</p>
              <p>阴历: {time.lunar}</p>
              <hr />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};